export default {
    "en_US": {
        translation: require("./en-US/translation").default
    },
    "zh_CN": {
        translation: require("./zh-CN/translation").default
    },
    "zh_TW": {
        translation: require("./zh-TW/translation").default
    }
}


// WEBPACK FOOTER //
// ./src/locales/locales.js